import { css } from 'lit';

export const styles = css`
  :host {
    --column-gap: calc(15rem / var(--default-rem-px-count));
  }

  :host(:not(:last-child)) > .expanded {
    padding-bottom: calc(40em / var(--default-rem-px-count));
  }

  .barrel-wrapper {
    height: calc(60em / var(--default-rem-px-count));
    overflow: hidden;
  }

  .expanded {
    height: unset;
  }

  .hide {
    display: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60em / var(--default-rem-px-count));
    border-top: 2px solid #222222;
  }

  .input-row-wrapper {
    border-bottom: 1px solid #c0c0c0;
    width: 100%;
    display: inline-grid;
    grid-template-columns:
      [mat-header]
      30%
      [mat-value]
      auto
      [end];
    padding-top: calc(24em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));
    gap: 1.5em 1em;
  }

  .cta-text-wrapper {
    padding-top: calc(24em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));
  }

  /* Override browser defaults */
  input[type='number'] {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
    border: 1px solid #cccccc;
    height: calc(32rem / var(--default-rem-px-count));
    width: calc(64rem / var(--default-rem-px-count));
    text-align: center;
  }

  .input-header {
    display: flex;
    align-items: center;
    gap: calc(10em / var(--default-rem-px-count));
  }

  .input-row-header {
    grid-area: 1 / mat-header;
    display: flex;
    gap: calc(5em / var(--default-rem-px-count));
  }

  .input-row-value {
    grid-area: 1 / mat-value;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20em / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  #add-choice-to-cart {
    margin-top: calc(-20em / var(--default-rem-px-count));

    .input-row-wrapper {
      width: 100%;
      display: inline-grid;
      grid-template-columns:
        [mat-header]
        30%
        [mat-value]
        auto
        [end];
      padding-top: calc(24em / var(--default-rem-px-count));
      padding-bottom: calc(20em / var(--default-rem-px-count));
      gap: 1.5em 1em;
      border-bottom: 1px solid #c0c0c0;
    }

    .ctas-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      padding-bottom: calc(20em / var(--default-rem-px-count));
      gap: 0 2em;
    }

    .no-border {
      border-bottom: none;
    }

    .input-row-header {
      grid-area: 1 / mat-header;
      display: flex;
      gap: calc(5em / var(--default-rem-px-count));
    }

    .input-row-value {
      grid-area: 1 / mat-value;
    }

    .input-header {
      display: flex;
      align-items: center;
      gap: calc(10em / var(--default-rem-px-count));
    }

    .total-price-header,
    .total-price-text {
      font-weight: 500;
      line-height: calc(28em / var(--default-rem-px-count));
    }

    .total-price-text {
      font-weight: 500;
    }

    .terms-details {
      padding: calc(20em / var(--default-rem-px-count)) 0;
    }

    .more-info {
      cursor: pointer;
    }

    .row-content-text p:not(:last-child) {
      padding-bottom: calc(8em / var(--default-rem-px-count));
    }

    .questions {
      padding-top: calc(20em / var(--default-rem-px-count));
      padding-left: calc(30em / var(--default-rem-px-count));
    }

    .contingecy-text-row {
      padding-top: calc(20em / var(--default-rem-px-count));
    }

    label {
      margin: auto 0;
    }

    .terms-label {
      color: inherit;
    }

    .terms-label-alert {
      color: red;
    }

    .terms-checkbox {
      display: flex;
      gap: calc(3rem / var(--default-rem-px-count));

      label {
        a {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    input[type='checkbox'] {
      appearance: none;
      -webkit-appearance: none;
      display: flex;
      align-content: center;
      justify-content: center;
      padding: 2px;
      border: 1px solid #222222;
      width: calc(18em / var(--default-rem-px-count));
      height: calc(18em / var(--default-rem-px-count));
    }

    input[type='checkbox']::before {
      content: '';
      width: calc(10em / var(--default-rem-px-count));
      height: calc(10em / var(--default-rem-px-count));
      transform: scale(0);
      background-color: #ff993d;
    }

    input[type='checkbox']:checked::before {
      transform: scale(1);
    }

    input[type='checkbox']:hover {
      cursor: pointer;
    }
  }

  .hardware-options-wrapper,
  .pattern-options-wrapper {
    width: 100%;
    padding-top: calc(16em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));
    margin-bottom: calc(20em / var(--default-rem-px-count));
    border-bottom: 1px solid #c0c0c0;
  }

  .pattern-options-wrapper:last-child {
    border-bottom: none;
  }

  .hardware-options-header,
  .pattern-options-header {
    padding-bottom: calc(20em / var(--default-rem-px-count));
  }

  .swatch-wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: calc(20em / var(--default-rem-px-count));
    cursor: pointer;
  }

  .swatch-wrapper span {
    display: flex;
  }

  .color-swatch span {
    width: 100%;
    display: block;
    aspect-ratio: 761 / 1000;
  }

  .image-swatch img {
    width: 100%;
    height: 100%;
  }

  .swatches {
    max-width: 100%;
    display: inline-grid;
    gap: calc(15em / var(--default-rem-px-count));
    grid-template-columns: repeat(
      5,
      minmax(0, calc(100em / var(--default-rem-px-count)))
    );
    padding-top: calc(20em / var(--default-rem-px-count));
  }

  .swatch-name {
    font-size: calc(10em / var(--default-rem-px-count));
    letter-spacing: -0.15px;
    padding-top: 2px;
    padding-left: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
    line-height: 1.3em;
    max-height: calc(14em / var(--default-rem-px-count));
  }

  .selected-swatch {
    padding: var(--selected-variant-padding-width);
    border: var(--selected-variant-border-width) solid #222222;
  }

  .not-selected-swatch {
    padding: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
  }

  .swatch-controls {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: calc(20em / var(--default-rem-px-count));
  }

  .swatch-page-controls {
    display: flex;
  }

  .swatch-page-controls span {
    cursor: pointer;
    width: calc(40em / var(--default-rem-px-count));
    height: calc(40em / var(--default-rem-px-count));
    display: flex;
    align-items: center;
  }

  .swatch-page-controls span {
    justify-content: center;
    margin: calc(5em / var(--default-rem-px-count));
  }

  .swatch-page-controls:hover span {
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .swatch-page-controls span img {
    width: 45%;
    height: 45%;
  }

  .no-results {
    height: calc(100em / var(--default-rem-px-count));
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-arrow {
    transform: rotate(180deg);
  }

  cta-button {
    margin-top: calc(30em / var(--default-rem-px-count));
    display: block;
    width: calc(50% - var(--column-gap));
  }

  .pattern-filters {
    display: flex;
    flex-direction: column;
    column-gap: var(--column-gap);
    padding-top: calc(10em / var(--default-rem-px-count));
  }

  .input-wrapper {
    flex-grow: 1;
    position: relative;
    display: flex;
  }

  .input-wrapper.search {
    border: 1px solid #222222;
  }

  .search input {
    width: 100%;
  }

  .option-group-wrapper > h3 {
    font-weight: 500;
  }

  /* Override browser defaults */
  input {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
    background: none;
  }

  input {
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-left: calc(16rem / var(--default-rem-px-count));
    display: block;
  }

  .search-icon {
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-right: calc(16rem / var(--default-rem-px-count));
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto;
  }

  @media (min-width: 600px) {
    .swatches {
      grid-template-columns: repeat(
        6,
        minmax(0, calc(100em / var(--default-rem-px-count)))
      );
    }
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .input-row-wrapper:not(:last-child) {
      border-bottom: 0.75px solid #c0c0c0;
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }

    .input-row-wrapper label,
    .input-row-wrapper p {
      font-size: 9px;
      letter-spacing: -0.05px;
      line-height: 12px;
    }

    .print-none {
      display: none !important;
    }
  }
`;
